import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useImperativeHandle, useRef } from "react";
import {
  Edit,
  NumberInput,
  SimpleForm,
  TextInput,
  useRecordContext,
  useRefresh,
} from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import useNotify from "../unit/useNotify";
import YesNoInput from "../unit/YesNoInput";
const EmployerLink = ({ ...props }) => {
  const id = props.id;
  const record = useRecordContext();
  const [employerLink, setEmployerLink] = React.useState(
    record?.share_url || ""
  );
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "general/employerlink";
    sendRequest(reqUrl, { id: id }).then((response) => {
      if (response) {
        setEmployerLink(response?.url);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(employerLink);
    success("Link copied to clipboard");
  };
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Employer URL"
        variant="outlined"
        value={employerLink}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate URL"}
                onClick={handleClick}
                edge="end"
                disabled={employerLink ? true : false}
              >
                <RefreshIcon color={employerLink ? "disabled" : "primary"} />
              </IconButton>

              <IconButton
                aria-label={"Copy URL"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined color="primary" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const ShowOriginalName = () => {
  const record = useRecordContext();
  return (
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      {record?.sCompany}
    </Typography>
  );
};
const EmployerStatusField = ({ ...props }) => {
  const record = useRecordContext();
  return (
    <>
      <Typography variant="body1" color="error" sx={{ mb: 2 }}>
        Note: If no product is selected, the status will automatically be set to
        disabled. To enable it, please select at least one product.
      </Typography>
    </>
  );
};
const EmployerEdit = (props: any) => {
  const formRef = useRef<HTMLDivElement | null>(null);
  if (props?.ref) {
    useImperativeHandle(props?.ref, () => ({
      submit: () => {
        formRef.current
          ?.querySelector("form")
          ?.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
      },
    }));
  }

  const id = props.id;
  const curTab = props.curTab;
  const refresh = useRefresh();
  const record = props.record;
  // console.log("data is ====>", record);
  //  const { getValues, setValue } = useFormContext();
  const [activeTab, setActiveTab] = React.useState(0);
  const showApplicationFee =
    record?.iApplicationFee > 0 || record?.sUniqueApplicationFee == "Yes";
  const showLoanAmount =
    record?.iLoanLimit > 0 || record?.sUniqueLoanMax == "Yes";
  // const [showCounselors, setShowCounselors] = React.useState(false);
  const [selectProduct, setSelectProduct] = React.useState<any[]>([]);
  const [selectCunselor, setSelectCounselor] = React.useState<any[]>([]);
  // const productCounselors = loadDataByLocalApi(
  //   "product_counselors",
  //   "productCounselors",
  //   1000
  // );
  const [productCounselors, setProductCounselors] = React.useState<any[]>([]);
  React.useEffect(() => {
    const reqUrl = "productCounselors";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      if (responseData) {
        setProductCounselors(responseData);
      }
    };
    fetchData();
  }, []);
  // const allExperts = loadDataByLocalApi("all_experts", "allExperts", 1000);
  const [allExperts, setAllExperts] = React.useState<any[]>([]);
  React.useEffect(() => {
    const reqUrl = "allExperts";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      if (responseData) {
        setAllExperts(responseData);
      }
    };
    fetchData();
  }, []);

  const handleSetSelectProductOrCounselor = (
    name: string,
    action: string,
    id: number
  ) => {
    if (name == "products") {
      if (action == "add") {
        setSelectProduct([...selectProduct, id]);
      } else if (action == "remove") {
        setSelectProduct(selectProduct.filter((item: any) => item !== id));
      }
    } else if (name == "counselors") {
      if (action == "add") {
        setSelectCounselor([...selectCunselor, id]);
      } else if (action == "remove") {
        setSelectCounselor(selectCunselor.filter((item: any) => item !== id));
      }
    }
  };
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  // start link product
  const handelShowCounselor = () => {
    //get all checked product ids
    let productIds = [];
  };

  const CounselorLink = ({ ...props }) => {
    const selectedExpert = props.selectedExpert;
    const selectedProduct = props.selectedProduct;

    let pcounselor: any[] = [];
    selectedProduct.map(async (pid: any) => {
      if (productCounselors) {
        var pcounselor2 = productCounselors?.find(
          (item: any) => item.id == pid
        );
        if (pcounselor2?.counselorCompanyList.length > 0) {
          pcounselor2?.counselorCompanyList.map((counselor: any) => {
            pcounselor.push(counselor);
          });
        }
      }
    });

    const CounselorLine = (props: any) => {
      const expert = props.expert;
      const defaultChecked = props.defaultChecked;
      const [cchecked, setCchecked] = React.useState(defaultChecked);
      return (
        <Typography key={expert.id} sx={{ mb: "10px" }}>
          <input
            type="checkbox"
            checked={cchecked}
            value={expert.id + `-` + expert.iAgencyId}
            className={"employer_select_expert counselor_" + expert.iAgencyId}
            onChange={(e) => {
              setCchecked(e.target.checked);
            }}
          />
          &nbsp;&nbsp;&nbsp;{expert.sName} - {expert.sFname} {expert.sLname}
        </Typography>
      );
    };
    return (
      <Box>
        {allExperts.map(
          (expert: any) =>
            pcounselor.includes(expert.iAgencyId) && (
              <CounselorLine
                expert={expert}
                defaultChecked={selectedExpert.includes(
                  expert.id + "-" + expert.iAgencyId
                )}
              />
            )
        )}
      </Box>
    );
  };
  const ProductLine = (props: any) => {
    const product = props.product;
    const [pchecked, setPchecked] = React.useState(props.checked);

    return (
      <>
        <Typography
          sx={{ color: product.iStatus ? "black" : "#ddd", mb: "10px" }}
        >
          <input
            type="checkbox"
            checked={pchecked}
            value={product.id}
            className="employer_select_product"
            onChange={(e) => {
              setPchecked(e.target.checked);
              props?.cb(product.id, e.target.checked);
            }}
          />
          {/* {product.id} */}
          &nbsp;&nbsp;&nbsp;{product.sProductName}
        </Typography>
      </>
    );
  };
  const CustomSelectProduct = (props: any) => {
    const record = useRecordContext();
    let selectArray = record?.empProducts;

    let experts = record?.experts; //employer linked experts
    // let selectIdArray: string[] = [];
    let defaultSelectPids: string[] = [];
    if (selectArray) {
      selectArray.forEach((product: any) => {
        defaultSelectPids.push(product.id);
      });
    }

    const [selectIdArray, setSelectIdArray] =
      React.useState<any[]>(defaultSelectPids);
    let productNums = 0;

    const changeSelectProducts = (id: number, checked: boolean) => {
      if (checked) {
        setSelectIdArray([...selectIdArray, id]);
      } else {
        setSelectIdArray(selectIdArray.filter((item: any) => item !== id));
      }
    };
    // console.log("selectIdArray is ===>", selectIdArray);
    if (record?.productList && record?.productList.length > 0) {
      return (
        <>
          <Box>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", color: "grey", marginBottom: "15px" }}
            >
              Select Products
            </Typography>
            {record?.productList.map((product: any) => (
              <li key={product.id} style={{ listStyle: "none" }}>
                <ProductLine
                  product={product}
                  checked={selectIdArray.includes(product.id)}
                  cb={changeSelectProducts}
                />
              </li>
            ))}
          </Box>
          {selectIdArray?.length > 0 && (
            <Box sx={{ marginTop: "30px" }}>
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", color: "grey", marginBottom: "15px" }}
              >
                Financial Counselor
              </Typography>
              <EmployerLink />
            </Box>
          )}
        </>
      );
    } else {
      return (
        <>
          Currently, there are no Employment-Based products available. Please go
          to the product page to add them.
        </>
      );
    }
  };

  const ApplicationFee = () => {
    return (
      <NumberInput
        source="iApplicationFee"
        name="application_fee"
        variant="outlined"
        label="Application Fee Amount"
      />
    );
  };

  // end link product
  return (
    <Edit
      {...props}
      id={id}
      basePath="/employers"
      resource="employers"
      sx={{
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
      }}
      className="employer_edit_dialog_form"
    >
      <SimpleForm toolbar={false} ref={formRef}>
        <Box sx={{ width: "100%", pt: 0 }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              marginTop: "0px",
              ".MuiCardContent": { paddingTop: 0 },
            }}
          >
            <ShowOriginalName />
          </Box>

          <>
            {curTab && curTab == "info" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
              >
                <TextInput
                  source="sCompany"
                  variant="outlined"
                  name="name"
                  label="Organization Name"
                  required={true}
                  helperText={false}
                />
                <Grid
                  container
                  spacing={1}
                  sx={{
                    mt: "0px",
                    "& .MuiGrid-item": {
                      pt: 0,
                    },
                  }}
                >
                  <Grid item xs={8}>
                    <TextInput
                      source="sAddress"
                      name="address"
                      variant="outlined"
                      label="Street"
                      required={true}
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextInput
                      source="sAddress2"
                      name="address2"
                      variant="outlined"
                      label="Street2"
                      required={true}
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextInput
                      source="sCity"
                      name="city"
                      variant="outlined"
                      label="City"
                      required={true}
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextInput
                      source="sState"
                      name="state"
                      variant="outlined"
                      label="State"
                      required={true}
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <NumberInput
                      source="sZip"
                      name="zipcode"
                      variant="outlined"
                      label="Zip"
                      required={true}
                      helperText={false}
                    />
                  </Grid>
                </Grid>
                {/* Contact Name */}
                <TextInput
                  source="sConnector"
                  name="contact_name"
                  variant="outlined"
                  label="Contact Name"
                  required={true}
                  helperText={false}
                />
                {/* Contact Email */}
                <TextInput
                  source="sEmail"
                  name="contact_email"
                  variant="outlined"
                  label="Contact Email"
                  required={true}
                  helperText={false}
                />
                {/* Contact Phone */}
                <TextInput
                  source="sContactPhone"
                  name="contact_phone"
                  variant="outlined"
                  label="Contact Phone"
                  required={true}
                  format={formatPhone}
                  parse={parsePhone}
                  helperText={false}
                />
                {showApplicationFee && (
                  <NumberInput
                    source="iApplicationFee"
                    name="application_fee"
                    variant="outlined"
                    label="Application Fee Amount"
                    helperText={false}
                  />
                )}

                {showLoanAmount && (
                  <NumberInput
                    source="iLoanLimit"
                    name="loan_amount_maximum"
                    variant="outlined"
                    label="Loan Amount Maximum"
                    helperText={false}
                  />
                )}
                <YesNoInput
                  source="sVerification"
                  label="Require verification"
                  name="employer_verification"
                  helperText={false}
                  sx={{ mt: 0, mb: 0 }}
                />
                <YesNoInput
                  source="sGuaranteeType"
                  label="Require guarantee"
                  name="guarantee"
                  helperText={false}
                  sx={{ mt: 0, mb: 0 }}
                />
              </Box>
            )}
            {curTab && curTab == "special" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
              >
                No special settings available.
              </Box>
            )}

            {curTab && curTab == "uniqueURL" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
              >
                {id && <EmployerLink id={id} />}
              </Box>
            )}

            {curTab && curTab == "linkProducts" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
                className="employer_product_section"
              >
                <EmployerStatusField />
                <CustomSelectProduct
                  source="productList"
                  // cb={handleSetSelectProductOrCounselor}
                />
              </Box>
            )}
          </>
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default EmployerEdit;
